import s from './style.css';
import cn from 'classnames';
import LineWrapper from 'components/LineWrapper';

const EmojiWordsGraph = ({ data, emoji, isEnd, inView }) => (
	<LineWrapper isEnd={isEnd}>
		<div className={cn(s.container, { [s.hidden]: !inView })}>
			<ul className={s.list}>
				{data.map(({ fact, factEmoji }, i) => {
					if (i % 2) return false;
					return (
						<li
							style={{
								transitionDelay: `${0.1 * i}s`
							}}
							className={s.item}
							data-emoji={factEmoji}
						>
							{fact}
						</li>
					);
				})}
			</ul>

			<ul className={cn(s.list, s.onRight)}>
				{data.map(({ fact, factEmoji }, i) => {
					if (!(i % 2)) return false;
					return (
						<li
							style={{
								transitionDelay: `${0.1 * i}s`
							}}
							className={s.item}
							data-emoji={factEmoji}
						>
							{fact}
						</li>
					);
				})}
			</ul>
		</div>
	</LineWrapper>
);

export default EmojiWordsGraph;



// WEBPACK FOOTER //
// ./components/EmojiWordsGraph/index.js